export default '/static/frontend/ReachDigital/12gobiking/dist/assets/ideal-871d1894.svg'